// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2w5PM","content":"Consent_content__1htNI","footer":"Consent_footer__14qlp"};